import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import i18next from 'i18next';
import FormQuestions from './components/FormQuestions';
import imgurl from './assests/images/imgurl';
import FormQuestionsPreview from './components/FormQuestionsPreview';
import { compressBase64Image, serviceDown } from './utils/UtilityFunctions';
import { postApi } from './api/services';
import MainLoader from './components/MainLoader';
import swal from 'sweetalert';

const DoctorProfile = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [editForm, setEditForm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formValues, setFormValues] = useState({
    first_name: '',
    last_name: '',
    c_name: '',
    c_address: '',
    city: '',
    postal_code: '',
    country: '',
    latitude: '',
    longitude: '',
    license_number: '',
    email: '',
    signature: ''
  });
  const [formQuestions, setFormQuestions] = useState([
    {
      title: "Clinic Name",
      type: "text",
      placeholder: "Enter clinic name",
      commonIdentifier: "clinic_name",
      questionId: 1
    },
    // {
    //   title: "Clinic Address",
    //   type: "address",
    //   placeholder: "Enter manual address",
    //   commonIdentifier: "c_address",
    //   questionId: 2
    // },
    {
      title: "First Name",
      type: "text",
      placeholder: "Enter first name",
      commonIdentifier: "first_name",
      questionId: 2
    },
    {
      title: "Last Name",
      type: "text",
      placeholder: "Enter last name",
      commonIdentifier: "last_name",
      questionId: 3
    },
    {
      title: "Phone Number",
      type: "number",
      placeholder: "Enter phone number",
      commonIdentifier: "phone_number",
      questionId: 4,
    },
    {
      title: "Email",
      type: "email",
      placeholder: "Enter email",
      commonIdentifier: "clinic_email",
      questionId: 5
    },
    {
      title: "License Number",
      type: "alphanumeric",
      placeholder: "Enter license number",
      commonIdentifier: "license_number",
      questionId: 6
    },
    {
      title: "Signature",
      type: "signature",
      placeholder: "Upload signature",
      commonIdentifier: "signature_base64",
      questionId: 7
    },
  ])
  const [formQuestionsFilled, setFormQuestionsFilled] = useState([
    {
      title: "Clinic Name",
      type: "text",
      placeholder: "Enter clinic name",
      commonIdentifier: "clinic_name",
      questionId: 1,
      // value: 'Test clinic'
    },
    // {
    //   title: "Clinic Address",
    //   type: "address",
    //   placeholder: "Enter clinic address",
    //   commonIdentifier: "c_address",
    //   questionId: 2,
    //   // value: 'Bombay Hospital'
    // },
    {
      title: "First Name",
      type: "text",
      placeholder: "Enter first name",
      commonIdentifier: "first_name",
      questionId: 2,
      // value: 'First'
    },
    {
      title: "Last Name",
      type: "text",
      placeholder: "Enter last name",
      commonIdentifier: "last_name",
      questionId: 3,
      // value: 'Last'
    },
    {
      title: "Phone Number",
      type: "number",
      placeholder: "Enter phone number",
      commonIdentifier: "phone_number",
      questionId: 4,
      // value: 'test@dure.com'
    },
    {
      title: "Email",
      type: "email",
      placeholder: "Enter email",
      commonIdentifier: "clinic_email",
      questionId: 5,
      // value: 'test@dure.com'
    },
    {
      title: "License Number",
      type: "alphanumeric",
      placeholder: "Enter license number",
      commonIdentifier: "license_number",
      questionId: 6,
      // value: 'LIC12345'
    },
    {
      title: "Signature",
      type: "signature",
      placeholder: "Upload signature",
      commonIdentifier: "signature_base64",
      questionId: 7,
      // value: imgurl.pdf_icon
    },
  ])

  useEffect(() => {
    // getProfileDetails()
    localStorage.getItem('user_role')?.toUpperCase() === 'DOCTOR' ? getDoctorProfile() : getNurseProfile()
  }, [])

  const getDoctorProfile = async () => {
    setIsLoading(true)
    let params = {
      phone_number: localStorage.getItem("phno")
    }
    console.log("get_doctor_by_phone params", params);
    try { 
      let res = await postApi('get_doctor_by_phone', params)
      console.log("get_doctor_by_phone res", res);
      setIsLoading(false)
      let newFilledValues = formQuestionsFilled.map((q) => ({
        ...q,
        value: res[q.commonIdentifier]
      }));
      let newFormQuestions = formQuestions.map((q) => ({
        ...q,
        value: res[q.commonIdentifier]
      }));
      console.log("newFilledValues", newFilledValues);
      setFormQuestionsFilled(newFilledValues)
      setFormQuestions(newFormQuestions)
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown('/loginpage') 
    }
  }

  const getNurseProfile = async () => {
    setIsLoading(true)
    let params = {
      phone_number: localStorage.getItem("phno")
    }
    console.log("get_nurse_by_phone params", params);
    try { 
      let res = await postApi('get_nurse_by_phone', params)
      console.log("get_nurse_by_phone res", res);
      setIsLoading(false)
      let nurseFormQuestionsFilled = formQuestionsFilled.filter(q => q.commonIdentifier !== 'license_number' && q.commonIdentifier !== 'signature_base64');
      let newFilledValues = nurseFormQuestionsFilled.map((q) => ({
        ...q,
        value: res[q.commonIdentifier]
      }));
      let nurseFormQuestions = formQuestions.filter(q => q.commonIdentifier !== 'license_number' && q.commonIdentifier !== 'signature_base64');
      let newFormQuestions = nurseFormQuestions.map((q) => ({
        ...q,
        value: res[q.commonIdentifier]
      }));
      console.log("newFilledValues", newFilledValues);
      setFormQuestionsFilled(newFilledValues)
      setFormQuestions(newFormQuestions)
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown('/loginpage') 
    }
  }

  const handleFormValues = async (value, identifier, action) => {
    let processedValue = value;

    if (identifier === "signature_base64") {
      processedValue = await compressBase64Image(value);
    }

    if(identifier === 'signature' && action === 'newupload'){
      processedValue = await compressBase64Image(value);
    }

    setFormValues((prev) => {
      const updated = { ...prev };

      switch (identifier) {
        case "first_name":
          updated.first_name = processedValue;
          break;
        case "last_name":
          updated.last_name = processedValue;
          break;
        case "name":
          updated.c_name = processedValue;
          break;
        case "c_address":
          updated.c_address = processedValue.address;
          updated.latitude = processedValue.lat;
          updated.longitude = processedValue.lng;
          updated.city = processedValue.city;
          updated.postal_code = processedValue.postalCode;
          updated.country = processedValue.country;
          break;
        case "license_number":
          updated.license_number = processedValue;
          break;
        case "email":
          updated.email = processedValue;
          break;
        case "signature":
          if(action === 'newupload'){
            updated.signature = processedValue;
          }
          break;
        case "signature_base64":
          updated.signature = processedValue;
          break;
        default:
          break;
      }
      return updated;
    });
  }

  // const getProfileDetails = async () => {
  //   const newFormQues = formQuestions.map((ques) => {
  //     let value = '';

  //     switch (ques.commonIdentifier) {
  //       case "first_name":
  //         value = 'First';
  //         handleFormValues(value, ques.commonIdentifier)
  //         break;
  //       case "last_name":
  //         value = 'Last';
  //         handleFormValues(value, ques.commonIdentifier)
  //         break;
  //       case "c_name":
  //         value = 'Test clinic';
  //         handleFormValues(value, ques.commonIdentifier)
  //         break;
  //       case "email":
  //         value = 'test@dure.com';
  //         handleFormValues(value, ques.commonIdentifier)
  //         break;
  //       case "license_number":
  //         value = 'LIC12345';
  //         handleFormValues(value, ques.commonIdentifier)
  //         break;  
  //       case "signature":
  //         value = imgurl.pdf_icon;
  //         // handleFormValues(value, ques.commonIdentifier)
  //         break;
  //       default:
  //         value = '';
  //     }
  //     return { ...ques, value }; // return a new object with value added
  //   });

  //   console.log("newFormQues", newFormQues);

  //   setFormQuestions(newFormQues)
  //   // formQuestions = newFormQuestions
  //   // setFormValues({
  //   //   d_name: 'Test doc',
  //   //   c_name: 'Test clinic',
  //   //   c_address: 'Mumbai',
  //   //   license_number: 'Test1234',
  //   //   signature: imgurl.pdf_icon
  //   // })
  // }

  const updateProfile = async () => {
    if(formValues.c_address){
      geocode(RequestType.ADDRESS, formValues.c_address)
        .then((res) => {
          console.log("resssss", res);
        })
        .catch((err) => {
          console.log("err", err);         
        })
    }
    // console.log("Form Values:", formValues);
    localStorage.getItem('user_role')?.toUpperCase() === 'DOCTOR' ? updateDoctorProfile() : updateNurseProfile()
  }

  const updateDoctorProfile = async () => {
    if(
      formValues.first_name === '' || 
      formValues.last_name === '' || 
      // formValues.c_name === '' ||
      // formValues.c_address === '' ||
      // formValues.email === '' ||
      formValues.license_number === '' ||
      formValues.signature === ''
    ) {
      swal({
        title: i18next.t("Please fill all the fields"),
        icon: "warning",
      })
    } else {
      setIsLoading(true)
      let docDetails = JSON.parse(localStorage.getItem('doctorobj'))
      let params = {
        doctor_id: docDetails.doctor_id,
        phone_number: docDetails.phone_number,
        // clinic_name: formValues.c_name,
        first_name: formValues.first_name,
        last_name: formValues.last_name,
        // email: formValues.email,
        license_number: formValues.license_number,
        signature: formValues.signature
      }
      console.log("update_doctor_details params", params);
      try {
        let res = await postApi('update_doctor_details', params)
        if(res.error) {
          setIsLoading(false)
          serviceDown(navigate)
        } else {
          setIsLoading(false)
          swal({
            title: i18next.t('Profile details updated'),
            icon: 'success'
          }).then(() => {
            navigate(-1); 
          })
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false)
        serviceDown(navigate)
      }
    }
  }

  const updateNurseProfile = async () => {
    if(
      formValues.first_name === '' || 
      formValues.last_name === '' 
      // formValues.c_name === '' ||
      // formValues.c_address === '' ||
      // formValues.email === '' ||
    ) {
      swal({
        title: i18next.t("Please fill all the fields"),
        icon: "warning",
      })
    } else {
      setIsLoading(true)
      let docDetails = JSON.parse(localStorage.getItem('doctorobj'))
      let params = {
        nurse_id: docDetails.nurse_id,
        phone_number: docDetails.phone_number,
        first_name: formValues.first_name,
        last_name: formValues.last_name,
      }
      console.log("update_nurse_details params", params);
      try {
        let res = await postApi('update_nurse_details', params)
        if(res.error) {
          setIsLoading(false)
          serviceDown(navigate)
        } else {
          setIsLoading(false)
          swal({
            title: i18next.t('Profile details updated'),
            icon: 'success'
          }).then(() => {
            navigate(-1); 
          })
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false)
        serviceDown(navigate)
      }
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='doctorprofilepage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate(-1)}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
            <Typography variant="h6" className="title">{i18next.t("Profile Details")}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid>
        </Grid>
        <div className='patientregpage-questions-container doctorprofile'>
          {
            editForm && formQuestions?.length > 0  ?
              formQuestions.map((ele) => {
                return (
                  <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                    <FormQuestions 
                      element={ele} 
                      handleFormValues={handleFormValues}
                      formValues={formValues}
                      doctorProfile={true}
                    />
                  </Grid>
                )
              }) 
                :
              formQuestionsFilled.length > 0 && formQuestionsFilled.map((ele) => { 
                return ele.value && ele.value && 
                (
                  <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                    <FormQuestionsPreview 
                      element={ele} 
                      handleFormValues={handleFormValues}
                      formValues={formValues}
                      doctorProfile={true}
                    />
                  </Grid>
                )
              })
          }
        </div>
          {
            editForm ? 
              <Button className='submitButton commonButton mt-10px' variant="contained" onClick={updateProfile}>
                {i18next.t("Submit")}
              </Button> 
                :
              <Button className='submitButton commonButton mt-10px' variant="contained" 
                onClick={() => setEditForm(true)}
              >
                {i18next.t("Update")}
              </Button>
          }
      </div>
    </>
  )
}

export default DoctorProfile